import { useState, useCallback } from 'react';

interface UseDrinkEffectReturn {
  drinking: boolean;
  finished: boolean;
  startDrinking: () => void;
  finishDrinking: () => void;
}

const useDrinkEffect = (): UseDrinkEffectReturn => {
  const [drinking, setDrinking] = useState(false);
  const [finished, setFinished] = useState(false);

  const startDrinking = useCallback(() => {
    if (!finished) {
      setDrinking(true);
    }
  }, [finished]);

  const finishDrinking = useCallback(() => {
    setDrinking(false);
    setFinished(true);
  }, []);

  return {
    drinking,
    finished,
    startDrinking,
    finishDrinking
  };
};

export default useDrinkEffect;
